<template>
  <b-form-group
    label="Situação de Cadastro"
    label-for="situacaoCadastro"
    label-class="font_size_label situacaoCadastro"
  >
    <validation-provider #default="{ errors }" name="Situação de Cadastro">
      <v-select
        id="situacaoCadastro"
        :options="options"
        v-model="selected"
        placeholder="Selecione a Situação de Cadastro"
        label="descricao"
        :clearable="true"
        multiselect
        multiple
      >
        <template #list-header v-if="ehMultiplo && options.length > 0">
          <div class="vs__dropdown-option" @click="toggleSelectAll">
            <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
            <span>Selecionar Todas</span>
          </div>
        </template>
        <span slot="no-options">Nenhuma opção selecionável.</span>
      </v-select>
      <small v-if="errors[0]" class="text-danger">
        {{ errors[0] }}
      </small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BForm,
  BCol,
  BRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BSpinner,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      options: [],
      selected: this.value,
    };
  },
  beforeMount() {
    this.options = [
      { descricao: "Completo", situacao_cadastro: "Completo" },
      { descricao: "Incompleto", situacao_cadastro: "Incompleto" },
      { descricao: "Parcial", situacao_cadastro: "Parcial" },
    ];
  },

  methods: {
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.options];
      }
    },
  },

  watch: {
    selected: function (valor) {
      this.$emit("selected", valor);
    },
  },

  computed: {
    ehMultiplo() {
      return this.options.length > 1;
    },
    isAllSelected() {
      return this.selected && this.selected.length === this.options.length;
    }
  },
};
</script>

